export default __webpack_public_path__ + "static/media/verify-email-illustration.78a0c2d3.svg";